import {EstimateState} from '@/model/api';
import {NetworkError} from '@/model/errors/NetworkError';
import {Either} from 'fp-ts/lib/Either';
import Vue from 'vue';

export default abstract class Segment<T extends EstimateState> extends Vue {

    public abstract hasNotSubmittedChanges(): boolean;

    public abstract clearNotSubmittedChanges(): void;

    /**
     * Submits given segment and either new state of estimate or error
     *
     * When Either is Left<null>, segment should provide feedback to user prompting him to correct any input errors.
     */
    public abstract submit(): Promise<Either<NetworkError|null, T>>;

    /**
     * Returns true if access to next segment is allowed.
     */
    public abstract allowsMovingOn(): boolean;

    /**
     * Prepare segment for appearing
     */
    public beforeEnter(): void {
    }
}
